define(
({
  "alert": "Upozornenie",
  "okay": "OK"
})
);
